// React:
import React from "react";
// React-Router-Dom:
import { useNavigate } from "react-router-dom";
// Redux Toolkit Hooks:
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
// Redux Toolkit Actions & State:
import { headerHamburgerMenuAction } from "./headerSlice";
import { drawerOpenOrCloseAction } from "../../main/home/drawer/drawerSlice";
import {
  logoutAction,
  authentication,
} from "../../authentication/authenticationSlice";
// MUI Components:
import { Box, Container, SvgIcon, useTheme } from "@mui/material";
// MUI Styles:
import { makeStyles } from "@mui/styles";
// Logo Icon:
import megaDL from "../../../assets/images/megaDL-Logo2.png";
import megaDL2 from "../../../assets/images/megaDL-Logo3.png";
// Icones:
import { ReactComponent as LogoutIcon } from "../../../assets/icons/logout-icon.svg";
import { ReactComponent as MenuIcon } from "../../../assets/icons/list-icon.svg";
import { getCookie } from "../../../configs/cookie-helper/cookieHelper";

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    height: "100%",
    minWidth: "100%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[2],
    [theme.breakpoints.down("sm")]: {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  logo: {
    width: "90px",
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      width: "35px",
    },
  },
}));

const Header = () => {
  const classes = useStyles();

  const theme = useTheme();

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const { token } = useAppSelector(authentication);

  const username = getCookie("username");

  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: { xs: "8px 16px" },
        m: { xs: 0 },
      }}
      className={classes.headerContainer}
    >
      <Box
        sx={{
          width: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          [theme.breakpoints.up("sm")]: {
            display: "none",
          },
        }}
        onClick={() => {
          dispatch(headerHamburgerMenuAction(true));
          dispatch(drawerOpenOrCloseAction(false));
        }}
      >
        <SvgIcon
          component={MenuIcon}
          inheritViewBox
          sx={{
            width: "20px",
            height: "20px",
            color: "inherit",
            stroke: "white",
            cursor: "pointer",
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          [theme.breakpoints.down("sm")]: {
            display: "none",
          },
        }}
        onClick={() => navigate("/")}
      >
        <Box
          component="img"
          src={megaDL}
          alt="MegaDL Logo"
          className={classes.logo}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          [theme.breakpoints.up("sm")]: {
            display: "none",
          },
        }}
      >
        <Box sx={{ margin: "0px 10px", color: "white", fontWeight: "bold" }}>
          {username}
        </Box>
        <Box
          sx={{ cursor: "pointer" }}
          onClick={() => navigate("/")}
          component="img"
          src={megaDL2}
          alt="MegaDL Logo"
          className={classes.logo}
        />
      </Box>

      {!!token && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            [theme.breakpoints.down("sm")]: {
              display: "none",
            },
          }}
        >
          <Box
            sx={{ margin: "0px 10px", color: "#DC4242", fontWeight: "bold" }}
          >
            {username}
          </Box>
          <SvgIcon
            onClick={() => {
              dispatch(logoutAction());
              navigate("/login");
            }}
            component={LogoutIcon}
            inheritViewBox
            sx={{
              width: "25px",
              cursor: "pointer",
              color: "#DC4242",
              [theme.breakpoints.down("sm")]: {
                color: "white",
              },
            }}
          />
        </Box>
      )}
    </Container>
  );
};

export default Header;
